import React from 'react';
import { FormattedMessage } from 'react-intl';

import { Text } from '@ps-design-system/components/Text';

import { usePauseModal } from '../context/PauseModalContext';

const SpaceInfo = () => {
  const { spaceTitle, spaceAddress, spaceImage } = usePauseModal();

  return (
    <div className="space-info-container">
      <div>
        <Text typeface="body-2-m">
          <FormattedMessage id="pause.modal.location" defaultMessage="Location"/>
        </Text>
      </div>
      <div className="image-container">
        <div>
          <img className="space-image" src={spaceImage}/>
        </div>
        <div className="space-info">
          <div>
            <Text typeface="body-2-m">
              {spaceTitle}
            </Text>
          </div>
          <div>
            <Text typeface="body-2">
              {spaceAddress}
            </Text>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SpaceInfo;
